import { requiredMessage } from "../utils/common";
var VARIANTS = {
  ARHI: "street address",
  IMAN: "address",
  IWHI: "address"
};
var invalidStreetAddressRegex = function invalidStreetAddressRegex(value) {
  return !/^[a-zA-Z0-9\-.,'\\ ]*$/.test(value);
};
var validStreetAddress = function validStreetAddress(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var error; // eslint-disable-line init-declarations
  if (!value) {
    error = requiredMessage(fieldName || VARIANTS[funnel] || VARIANTS.ARHI);
  } else if (invalidStreetAddressRegex(value)) {
    error = "Only letters, numbers, spaces and the following special characters may be used: \u2018 -,.";
  }
  return error;
};
export default validStreetAddress;